import { Heading4 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import { FloorData, propertyFloorFormatter } from '@/utils/floors'

export const Floor: React.FC<FloorData> = ({ buildingFloors, entireBuilding, entranceFloor, floorPosition }) => {
  const { t } = useTranslation()
  const floorFormatted = propertyFloorFormatter({ buildingFloors, entireBuilding, entranceFloor, floorPosition }, t)

  if (
    entireBuilding ||
    entranceFloor < 0 ||
    entranceFloor === 0 ||
    entranceFloor === buildingFloors ||
    (floorPosition && floorPosition.length > 0 && floorPosition[0] !== 'MID_FLOOR')
  ) {
    return (
      <span>
        {floorFormatted}
        {entranceFloor === buildingFloors && entranceFloor !== null && (
          <span>
            {' '}
            {t('common:of2')} {buildingFloors}
          </span>
        )}
      </span>
    )
  }
  return (
    <span>
      {floorFormatted}{' '}
      {buildingFloors !== null && entranceFloor < buildingFloors && (
        <span>
          {t('common:of')} {buildingFloors}
        </span>
      )}
    </span>
  )
}
